//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Preferences.js";
import "../no/Builder.js";
import "../no/LineFontBuilder.js";
import "../no/LineFontBuilder.js";
let d=[[[0,"ActionAfterInterruptValue",1,0],[0,"ActivateTrimmedAnimation",1,0],[0,"AnalysisBodyMaterialName",1,0],[0,"AngleTolerance",1,0],[0,"AssociativeFreeFormEdit",1,0],[0,"BodyTypeValue",1,0],[0,"C0KnotLineColorValue",1,0],[1,"C0KnotLineStyleValue",0,"LineFontBuilder",0],[0,"C1KnotLineColorValue",1,0],[1,"C1KnotLineStyleValue",0,"LineFontBuilder",0],[0,"C2KnotLineColorValue",1,0],[1,"C2KnotLineStyleValue",0,"LineFontBuilder",0],[0,"CopyAttributesOnSplit",1,0],[0,"CurveFitMethodValue",1,0],[0,"DelayModelUpdate",1,0],[0,"DeleteChildFeaturesValue",1,0],[0,"DensityUnitsValue",1,0],[0,"DensityValue",1,0],[0,"DistanceTolerance",1,0],[0,"DynamicsUpdateLevelValue",1,0],[0,"DynamicsUpdateModeValue",1,0],[0,"EditDuringUpdateDialogOnError",1,0],[0,"EditDuringUpdateDialogOnWarning",1,0],[0,"EditPoleColorValue",1,0],[0,"EditPoleStyleValue",1,0],[0,"EditPolylineColorValue",1,0],[1,"EditPolylineStyleValue",0,"LineFontBuilder",0],[0,"EditSpecifcPoleColor",1,0],[0,"EditSpecificPolylineColorValue",1,0],[0,"EndPointColorValue",1,0],[0,"EndPointStyleValue",1,0],[0,"FacesModifiedByBooleanValue",1,0],[0,"FacetAngleTolerance",1,0],[0,"FacetDistanceTolerance",1,0],[0,"FeatureDoubleClickActionValue",1,0],[0,"GridLineColorValue",1,0],[1,"GridLineStyleValue",0,"LineFontBuilder",0],[0,"HideResult",1,0],[0,"LimitChordLengthToMax",1,0],[0,"LimitFacetWidthToMaximum",1,0],[0,"LinkOrExtractGeometryValue",1,0],[0,"MakeCurrentFeatureOnError",1,0],[0,"MakeSketchInternal",1,0],[0,"MaxChordLength",1,0],[0,"MaxFacetWidth",1,0],[0,"MaxRebuildDegree",1,0],[0,"MaxRebuildSegments",1,0],[0,"ModelDelayAndUpdateGranularityValue",1,0],[0,"ModelingModeValue",1,0],[0,"NewFacesValue",1,0],[0,"NotifyOnDelete",1,0],[0,"OptimizeCurve",1,0],[0,"OptimizeCurveAngleTol",1,0],[0,"OptimizeCurveDitanceTol",1,0],[0,"PlanarFaceTypeValue",1,0],[0,"PoleColorValue",1,0],[0,"PoleStyleValue",1,0],[0,"PolylineColorValue",1,0],[1,"PolylineStyleValue",0,"LineFontBuilder",0],[0,"PreviewResolutionValue",1,0],[0,"ReportWarningAfterUpdate",1,0],[0,"ShowParentSketchDim",1,0],[0,"ShowSimulation",1,0],[0,"ShowSymbolicThreadDecalSticker",1,0],[0,"SketchDoubleClickActionValue",1,0],[0,"SpecificC0KnotLineColor",1,0],[0,"SpecificC1KnotLineColor",1,0],[0,"SpecificC2KnotLineColor",1,0],[0,"SpecificEndPointColor",1,0],[0,"SpecificGridLineColor",1,0],[0,"SpecificPoleColor",1,0],[0,"SpecificPolylineColor",1,0],[0,"SplineDoubleClickActionValue",1,0],[0,"SurfaceExtensionValue",1,0],[0,"TreatDegrre1SplineAsPolyline",1,0],[0,"UGridLines",1,0],[0,"UseTriangularMesh",1,0],[0,"VGridLines",1,0],[0,"WarnOnMissingReference",1,0]],[],[]];
SPLM.Preferences.ModelingPreferencesBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Preferences.ModelingPreferencesBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Preferences.ModelingPreferencesBuilder.BodyType = Object.freeze({
    "Solid" : "Solid", "Sheet" : "Sheet"});

SPLM.Preferences.ModelingPreferencesBuilder.DensityUnits = Object.freeze({
    "Lbmin3" : "Lbmin3", "Lbmft3" : "Lbmft3", "Gcm3" : "Gcm3", "Kgm3" : "Kgm3"});

SPLM.Preferences.ModelingPreferencesBuilder.NewFaces = Object.freeze({
    "InheritfromParent" : "InheritfromParent", "InheritObjectPreferences" : "InheritObjectPreferences"});

SPLM.Preferences.ModelingPreferencesBuilder.FaceModifiedByBoolean = Object.freeze({
    "InheritfromTargetBody" : "InheritfromTargetBody", "InheritfromToolBody" : "InheritfromToolBody"});

SPLM.Preferences.ModelingPreferencesBuilder.LinkOrExtractGeometry = Object.freeze({
    "InheritfromParent" : "InheritfromParent", "InheritObjectPreferences" : "InheritObjectPreferences"});

SPLM.Preferences.ModelingPreferencesBuilder.ModelingMode = Object.freeze({
    "HistoryFree" : "HistoryFree", "History" : "History"});

SPLM.Preferences.ModelingPreferencesBuilder.FeatureDoubleClickAction = Object.freeze({
    "EditParameter" : "EditParameter", "EditwithRollback" : "EditwithRollback"});

SPLM.Preferences.ModelingPreferencesBuilder.SketchDoubleClickAction = Object.freeze({
    "EditwithRollback" : "EditwithRollback", "DirectEdit" : "DirectEdit"});

SPLM.Preferences.ModelingPreferencesBuilder.DeleteChildFeatures = Object.freeze({
    "Yes" : "Yes", "No" : "No", "Ask" : "Ask"});

SPLM.Preferences.ModelingPreferencesBuilder.ModelDelayAndUpdateGranularity = Object.freeze({
    "Group" : "Group", "Feature" : "Feature"});

SPLM.Preferences.ModelingPreferencesBuilder.DynamicUpdateMode = Object.freeze({
    "None" : "None", "Incremental" : "Incremental", "Continuous" : "Continuous"});

SPLM.Preferences.ModelingPreferencesBuilder.DynamicsUpdateLevel = Object.freeze({
    "First" : "First", "All" : "All"});

SPLM.Preferences.ModelingPreferencesBuilder.ActionAfternterrupt = Object.freeze({
    "MakeLastSuccessfulFeatureCurrent" : "MakeLastSuccessfulFeatureCurrent", "Undo" : "Undo"});

SPLM.Preferences.ModelingPreferencesBuilder.CurveFitMethod = Object.freeze({
    "Cubic" : "Cubic", "Quintic" : "Quintic", "Advanced" : "Advanced"});

SPLM.Preferences.ModelingPreferencesBuilder.PlanarFaceType = Object.freeze({
    "Plane" : "Plane", "Bsurface" : "Bsurface"});

SPLM.Preferences.ModelingPreferencesBuilder.SurfaceExtension = Object.freeze({
    "Linear" : "Linear", "Soft" : "Soft"});

SPLM.Preferences.ModelingPreferencesBuilder.SplineDefaultClickAction = Object.freeze({
    "StudioSpline" : "StudioSpline", "XForm" : "XForm"});

SPLM.Preferences.ModelingPreferencesBuilder.PreviewResolution = Object.freeze({
    "None" : "None", "Coarse" : "Coarse", "Standard" : "Standard", "Fine" : "Fine", "ExtraFine" : "ExtraFine", "SuperFine" : "SuperFine", "UltraFine" : "UltraFine"});

SPLM.Preferences.ModelingPreferencesBuilder.PoleColor = Object.freeze({
    "BodyColor" : "BodyColor", "SpecificColor" : "SpecificColor"});

SPLM.Preferences.ModelingPreferencesBuilder.PoleStyle = Object.freeze({
    "ThreeDimensionSphere" : "ThreeDimensionSphere", "OpenCircle" : "OpenCircle", "FilledCircle" : "FilledCircle", "PlusSign" : "PlusSign", "Cross" : "Cross"});

SPLM.Preferences.ModelingPreferencesBuilder.EditPoleColor = Object.freeze({
    "BodyColor" : "BodyColor", "SpecificColor" : "SpecificColor"});

SPLM.Preferences.ModelingPreferencesBuilder.EditPoleStyle = Object.freeze({
    "ThreeDimensionSphere" : "ThreeDimensionSphere", "OpenCircle" : "OpenCircle", "FilledCircle" : "FilledCircle", "PlusSign" : "PlusSign", "Cross" : "Cross"});

SPLM.Preferences.ModelingPreferencesBuilder.PolylineColor = Object.freeze({
    "BodyColor" : "BodyColor", "SpecificColor" : "SpecificColor"});

SPLM.Preferences.ModelingPreferencesBuilder.EditPolylineColor = Object.freeze({
    "BodyColor" : "BodyColor", "SpecificColor" : "SpecificColor"});

SPLM.Preferences.ModelingPreferencesBuilder.GridLineColor = Object.freeze({
    "BodyColor" : "BodyColor", "SpecificColor" : "SpecificColor"});

SPLM.Preferences.ModelingPreferencesBuilder.C0KnotLineColor = Object.freeze({
    "BodyColor" : "BodyColor", "SpecificColor" : "SpecificColor"});

SPLM.Preferences.ModelingPreferencesBuilder.C1KnotLineColor = Object.freeze({
    "BodyColor" : "BodyColor", "SpecificColor" : "SpecificColor"});

SPLM.Preferences.ModelingPreferencesBuilder.C2KnotLineColor = Object.freeze({
    "BodyColor" : "BodyColor", "SpecificColor" : "SpecificColor"});

SPLM.Preferences.ModelingPreferencesBuilder.EndPointColor = Object.freeze({
    "CurveColor" : "CurveColor", "SpecificColor" : "SpecificColor"});

SPLM.Preferences.ModelingPreferencesBuilder.EndPointStyle = Object.freeze({
    "OpenCircle" : "OpenCircle", "FilledCircle" : "FilledCircle", "PlusSign" : "PlusSign", "Cross" : "Cross", "Point" : "Point", "Asterisk" : "Asterisk", "PoundSign" : "PoundSign", "FilledSquare" : "FilledSquare", "FilledTriangle" : "FilledTriangle", "FilledDiamond" : "FilledDiamond", "Centerline" : "Centerline"});

export default SPLM;